import { FC } from 'react';
import type { RejectedWithPriceTileData } from 'state/quotes/dashboard/model';

import { Price, PricingDate, ResultPanel, SolveModeLabel, TileLayout } from './components';
import { Rejections } from './components/rejections';
import type { TileContentProps } from './Tile.common';

export const RejectedWithPriceTile: FC<TileContentProps<RejectedWithPriceTileData>> = ({
  data,
  quoteId,
  header,
  subHeader,
  footer,
}) => {
  const hasPrice = data.solveResult !== undefined;

  return (
    <TileLayout header={header} subHeader={subHeader} footer={footer}>
      <ResultPanel
        color="danger"
        solveModeLabel={<SolveModeLabel value={data.solveMode} size="small" />}
        price={
          hasPrice && (
            <Price
              solveResult={data.solveResult}
              solveResultFormat={data.solveResultFormat}
              xMargin={data.xMargin}
              color="danger"
              compactMode
            />
          )
        }
        statusPanel={
          <Rejections
            id={quoteId}
            shouldDisplayErrorDetails={data.shouldDisplayErrorDetails}
            errorMessages={data.errorMessages}
          />
        }
        subHeader={<PricingDate when={data.lastUpdated} />}
      />
    </TileLayout>
  );
};

RejectedWithPriceTile.displayName = 'RejectedWithPriceTile';
